import { StatusEnum } from './statusEnum'
import { StatusEnumItem } from './StatusEnumItem'

const Draft = new StatusEnumItem({
  description: 'The Lot was created, but not ready to submit',
  id: '385c1ee0-1342-4baf-a46a-20a0a2774f69',
  name: 'Draft',
  priority: 0,
})

const Closed = new StatusEnumItem({
  description: 'The Lot is submitted and closed',
  id: '043dae53-07ac-4bcf-a5f5-c44532305e60',
  name: 'Closed',
  priority: 1,
})

export type LIMSAsphaltLotStatusItem = typeof Draft | typeof Closed

class LIMSAsphaltLotStatusEnum extends StatusEnum<
  'LIMSAsphaltLotStatus',
  LIMSAsphaltLotStatusItem,
  LIMSAsphaltLotStatusItem['name'],
  LIMSAsphaltLotStatusItem['id'],
  LIMSAsphaltLotStatusItem['priority']
> {
  readonly Draft = Draft
  readonly Closed = Closed

  typename = 'LIMSAsphaltLotStatus' as const
  get values() {
    return [this.Draft, this.Closed]
  }
}

export const LIMSAsphaltLotStatus = new LIMSAsphaltLotStatusEnum()
